// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_OpcoesDeAtributoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /usuarios/opcoes_de_atributo/<atributo> (skill `app-groups`): as opções
 * que o serviço dono do atributo serve no seu /access-catalog, repassadas à tela de usuários.
 */
import type { Usuarios_OpcaoDeAtributoRow } from './Usuarios_OpcaoDeAtributoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Usuarios_OpcoesDeAtributoResponseDados {
atributo: string
opcoes: Usuarios_OpcaoDeAtributoRow[]
}

export type Usuarios_OpcoesDeAtributoResponse = ApiResponse<Usuarios_OpcoesDeAtributoResponseDados>;

registerResponseContract('Usuarios_OpcoesDeAtributoResponse', {
  atributo: { type: 'string',  required: true },
  opcoes: {
    type: 'array',
    required: true,
    items: {
      id:          { type: 'string',  required: true },
      label:       { type: 'string',  required: true },
      scope:       { type: 'string',  required: true },
      description: { type: 'string',  required: false },
      group:       { type: 'string',  required: false },
      sensitive:   { type: 'boolean', required: false },
    },
  },
})
